export { SentryMonitoringService } from './services/sentry-monitoring.service';

// Re-export Sentry webpack plugin for Next.js config
export { withSentryConfig } from '@sentry/nextjs';

// Export initialization functions for Sentry client and server
export { initializeSentryBrowserClient } from './sentry.client.config';
export { initializeSentryServerClient } from './sentry.server.config';

// Drop-sink payload contracts (BAL-856 `beforeSend`, BAL-959 `event_processor`).
// Exported so a CONSUMER's handler is checked against the real payload shape
// instead of a hand-written structural cast that drifts silently when a field
// is added — which is how a boolean sat in a `Record<string, string>` slot in
// the web app's own test of this sink.
export type {
  IgnoredDropInfo,
  IgnoredDropHandler,
  ProcessorDropInfo,
  ProcessorDropHandler,
  SinkArmedInfo,
  SinkArmedHandler,
} from './sentry.client.config';
